import { ExternalUrlsService } from '@/app/services/external-urls.service';
import { MixPanelEvent, MixPanelService } from '@/app/services/mixpanel.service';
import { Component, computed, CUSTOM_ELEMENTS_SCHEMA, inject, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'dr-flex-home-ui-header-most-visited',
  imports: [TranslateModule],
  templateUrl: './header-most-visited.component.html',
  styleUrl: './header-most-visited.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HeaderMostVisitedComponent {
  private readonly externalUrlsService = inject(ExternalUrlsService);
  private readonly mixpanelService = inject(MixPanelService);

  hasCOM = input.required<boolean>();
  mostVisitedButtons = computed<{ label: string; url: string; mixPanelEvent: MixPanelEvent }[]>(() => {
    return [
      { label: 'FLEX_HOME.HOME.MOST_VISITED.BUTTONS.TRENDS', url: this.externalUrlsService.trends, mixPanelEvent: MixPanelEvent.CLICK_GO_TRENDS },
      ...(this.hasCOM() ? [{ label: 'FLEX_HOME.HOME.MOST_VISITED.BUTTONS.COM', url: this.externalUrlsService.com, mixPanelEvent: MixPanelEvent.CLICK_GO_COM }] : []),
      { label: 'FLEX_HOME.HOME.MOST_VISITED.BUTTONS.ACTIVE_DISPATCHES', url: this.externalUrlsService.activeEvents, mixPanelEvent: MixPanelEvent.CLICK_GO_ACTIVE_DISPATCHES },
    ];
  });

  openLink(url: string, mixPanelEvent: MixPanelEvent) {
    this.trackMixpanelClickEvent(mixPanelEvent);
    window.open(url, '_blank');
  }

  private trackMixpanelClickEvent(mixPanelEvent: MixPanelEvent): void {
    if (!mixPanelEvent) {
      return;
    }

    this.mixpanelService.trackEvent(mixPanelEvent);
  }
}
